import { SET_VALUE } from './intercom.actionTypes';

const initialState = {};

// eslint-disable-next-line default-param-last
export function intercomReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_VALUE: {
      return payload;
    }
    default:
      return state;
  }
}
